import React from "react";
import T from "i18n-react";
import route from "@route";
import clsx from "clsx";

import AdaptiveImage from "@components/AdaptiveImage";
import Link from "@components/LocalizedLink";

export function NavColumnHeader({ className, children }) {
	let cssClass = clsx("main_nav__column_header py-4 font-bold", className);

	if (!className || !className.match(/px-\d+/)) {
		cssClass += " px-5";
	}

	return <div className={cssClass}>{children}</div>;
}

export function NavFeatured({ thumbnail, title, to, className, description = "", cta = "" }) {
	if (cta === "") {
		cta = T.translate("nav.learnMore");
	}

	return (
		<Link to={to} className={clsx("main_nav__featured w-full block", className)}>
			<AdaptiveImage src={thumbnail} className="w-full h-auto rounded-8 mb-4" loading="lazy" height={140} width={280} />
			<h4 className="text-15 text-bold text-ash mb-1">{title}</h4>
			<p className="text-14 text-ash mb-6">{description}</p>
			<span className="link_cerulean_arrow text-cerulean text-13 font-medium uppercase">{cta}</span>
		</Link>
	);
}

export function NavMiniFeatured({ thumbnail, title, to, className, description = "", cta = "" }) {
	if (cta === "") {
		cta = T.translate("nav.learnMore");
	}

	return (
		<Link to={to} className={clsx("main_nav__mini_featured w-full block bg-zircon rounded-10 p-5 pb-3 hover:bg-white", className)}>
			<span className="grid">
				<span className="col-4 flex align-items-center">
					<AdaptiveImage src={thumbnail} className="w-full h-auto rounded-8" loading="lazy" height={75} width={75} />
				</span>
				<span className="col-8 flex flex-wrap align-content-center">
					<h4 className="text-15 text-bold text-ash mb-1 w-full">{title}</h4>
					{description && <p className="text-14 text-ash mb-6 w-full">{description}</p>}
					<span className="link_cerulean_arrow text-cerulean text-13 font-medium uppercase w-full">{cta}</span>
				</span>
			</span>
		</Link>
	);
}

export function NavItem({ id, onMouseOver, onFocus, sub = "", className = "", to = "", langs = ["all"] }) {
	const px = className.match(/px-\d{1,2}/) ? "" : "px-5";
	const py = className.match(/py-\d{1,2}/) ? "" : "py-4";

	if (langs[0] === "all" || langs.includes(T.translate("key"))) {
		if (to === "") {
			to = route(id);
		}

		if (id === "events") {
			to = route("events", "en");
		}

		if (sub !== "") {
			return (
				<Link to={to} className={clsx("main_nav__link font-bold", px, py, className)} onMouseOver={onMouseOver} onFocus={onFocus}>
					<span>{T.translate(`nav.${id}`)}</span>
					<span className="text-13 font-regular">{T.translate(`nav.${sub}`)}</span>
				</Link>
			);
		}

		return (
			<Link to={to} className={clsx("main_nav__link font-bold", px, py, className)} onMouseOver={onMouseOver} onFocus={onFocus}>
				{T.translate(`nav.${id}`)}
			</Link>
		);
	}

	return null;
}
